module.exports = __webpack_public_path__ + "img/elhegawi.ee097e83.jpg";